import { BaseWebComponentController, IListenerConfig } from '../../../../framework/BaseWebComponentController';
import { EXPORT_CSV_RESULT_METADATA_EVENT, LiveSearchMetadataGridViewData } from '../types';
import { LiveSearchMetadataGridComponent } from '../component/LiveSearchMetadataGridComponent';
import LiveSearchMetadataGridRepository from '../repository/LiveSearchMetadataGridRepository';
import LiveSearchMetadataGridView from '../view/LiveSearchMetadataGridView';
import liveSearchMetadataGridTemplate from '../view/template';
import { convertGridFiltersToExtJsFilters } from '../../../../grid/utils/filters';
import { QueryExecution } from '../../types';
import { GridEvents } from '../../../../grid/types/common';
import { showToast } from '@nirvana/shared/common';
import { ToastSeverity } from '../../../../ui/gzToastNotification/type';

export default class LiveSearchMetadataGridController extends BaseWebComponentController {
  public dataRepository: LiveSearchMetadataGridRepository;
  public view: LiveSearchMetadataGridView;

  constructor(public component: LiveSearchMetadataGridComponent) {
    super(component);

    this.initialSetup({
      dataRepositoryConstructor: LiveSearchMetadataGridRepository,
      viewConstructor: LiveSearchMetadataGridView,
      viewTemplate: liveSearchMetadataGridTemplate,
    });
  }

  public computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$grid.controller?.view.dom.$grid,
        event: 'selected-items-changed',
        callback: this.setAssignTagsButtonState,
      },
      {
        element: this.view.dom.$grid.controller?.view.dom.$grid,
        event: GridEvents.GRID_SELECT_ALL,
        callback: this.setAssignTagsButtonState,
      },
      {
        element: this.view.dom.$assignTagsButton,
        event: 'click',
        callback: this.openAssignTagsWindow,
      },
      {
        element: this.view.dom.$downloadMetadataTooltip,
        event: 'click',
        callback: this.downloadMetadataCSV,
      },
    ];
  }

  public async getDataForView(): Promise<LiveSearchMetadataGridViewData> {
    return this.dataRepository.getDataForView(this.component.getQueryExecution());
  }

  private setAssignTagsButtonState(): void {
    const disabled = 0 === this.view.dom.$grid.selectedItems?.length && !this.view.dom.$grid.isAllSelected;

    this.view.setAssignTagsButtonState(disabled);
  }

  private openAssignTagsWindow(): void {
    const queryExecution = this.component.getQueryExecution() as QueryExecution,
      parameters: any[] = [queryExecution._id];

    if (this.view.dom.$grid.isAllSelected) {
      parameters.push(null, convertGridFiltersToExtJsFilters(this.view.dom.$grid.filters));
    } else {
      parameters.push(
        this.view.dom.$grid.selectedItems?.map((item: any): string => item._id),
        null
      );
    }

    parameters.push(queryExecution.companyId, this.onAssignTagsSuccess.bind(this), this.onAssignTagsFailure.bind(this));

    this.dependencies.openAssignTagsWindowForEndpointsOfLiveSearchResultsMetadata(...parameters);
  }

  private downloadMetadataCSV(): void {
    this.component.dispatchEvent(
      new CustomEvent(EXPORT_CSV_RESULT_METADATA_EVENT, {
        detail: {},
        bubbles: true,
        composed: true,
      })
    );
  }

  public onAssignTagsSuccess(): void {
    showToast(this.dependencies.translateFn('Assigning tags...'), ToastSeverity.INFORMATIVE);
    this.view.refreshGrid();
  }

  public onAssignTagsFailure(): void {
    showToast(this.dependencies.translateFn('Assigning tags has failed. Please try again later.'), ToastSeverity.ERROR);
  }
}
